module.exports = __webpack_public_path__ + "media/bootstrap-icons/heart-half-9ddef6e8.svg";